/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Col, Row } from 'antd';
import clsx from 'clsx';

const FormFieldEmulation = ({ children, label, style, className, wrapLabel = 3, wrapperCol = 21 }) => (
  <Row style={style} className={clsx('ant-form-item', className)}>
    <Col span={wrapLabel} className="ant-form-item-label ant-form-item-label-left">
      <strong>{label}</strong>
    </Col>
    <Col span={wrapperCol}>{children}</Col>
  </Row>
);

export default FormFieldEmulation;
